import React from 'react';
import { MapPin, Navigation, X } from 'lucide-react';
import { BicycleParkingLocation } from '../types';

interface BicycleParkingPopupProps {
  location: BicycleParkingLocation;
  onClose: () => void;
}

const BicycleParkingPopup: React.FC<BicycleParkingPopupProps> = ({ location, onClose }) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="bicycle-parking-modal-backdrop" onClick={handleBackdropClick}>
      <div className="bicycle-parking-modal">
        {/* Modal Header */}
        <div className="modal-header">
          <h3 className="modal-title">Bicycle Parking</h3>
          <button onClick={onClose} className="modal-close-button">
            <X size={20} />
          </button>
        </div>

        {/* Modal Content */}
        <div className="modal-content">
          <div className="location-details">
            <div className="detail-row">
              <span className="detail-label">Street:</span>
              <span className="detail-value">{location.streetName}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Suburb:</span>
              <span className="detail-value">{location.suburb}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Coordinates:</span>
              <span className="detail-value">
                {location.latitude.toFixed(6)}, {location.longitude.toFixed(6)}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="modal-actions">
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${location.latitude},${location.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="directions-button"
            >
              <Navigation size={16} />
              Get Directions
            </a>
            <a
              href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${location.latitude},${location.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="streetview-button"
            >
              <MapPin size={16} />
              Street View
            </a>
          </div>

          {/* Powered by City of Sydney Card */}
          <div className="powered-by-sydney-card">
            <div className="powered-by-content">
              <div className="powered-by-text">Powered by</div>
              <div className="city-of-sydney-logo">
                <img
                  src="/instantAppsConfigPanel_1712885390298_Anchor_White.png"
                  alt="City of Sydney Logo"
                  className="city-logo-image"
                />
                <span className="city-name">City of Sydney</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BicycleParkingPopup;
